export enum ServiceType {
	Meal = 'Meal',
	Baggage = 'Baggage',
	Seats = 'Seats',
	Transfer = 'Transfer',
	Insurance = 'Insurance'
}
